import { colors } from '@material-ui/core';

export const breadcrumb = [
  {
    href: '#',
    title: 'Help Center',
    isActive: false,
  },
  {
    href: '#',
    title: 'Articles',
    isActive: false,
  },
  {
    title: 'Account',
    isActive: true,
  },
];

export const questions = {
  title: 'Account',
  subtitle: 'Let’s try to fix your account issues.',
  icon: 'fas fa-user',
  color: colors.amber,
  items: [
    {
      id: 'faq-1',
      title: 'Authentication Issues',
      subtitle: 'Issues related to logging in, out, or about multiple devices.',
      text:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
      link: 'Contact support team',
    },
    {
      id: 'faq-2',
      title: 'Why doesn’t my account stay logged in?',
      subtitle: 'Issues related to authentication',
      text:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
      link: 'Contact support team',
    },
    {
      id: 'faq-3',
      title: "I'd like to renew but I am getting a 404 error.",
      subtitle: 'Issues related to renewal',
      text:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
      link: 'Contact support team',
    },
    {
      id: 'faq-4',
      title: "Why can't I upgrade for free?",
      subtitle: 'Payment gateway related issues',
      text:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
      link: 'Contact support team',
    },
    {
      id: 'faq-5',
      title: "Why doesn't my account stay logged in?",
      subtitle: 'Login session related issues',
      text:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
      link: 'Contact support team',
    },
    {
      id: 'faq-6',
      title: 'Can I use referral code to decrease my monthly fees?',
      subtitle: 'Referral bonuses and charging',
      text:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
      link: 'Contact support team',
    },
    {
      id: 'faq-7',
      title: 'Authentication Issues',
      subtitle: 'Issues related to logging in, out, or about multiple devices.',
      text:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
      link: 'Contact support team',
    },
    {
      id: 'faq-8',
      title: 'Why doesn’t my account stay logged in?',
      subtitle: 'Issues related to authentication',
      text:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
      link: 'Contact support team',
    },
  ],
};
export const categories = [
  {
    title: 'Billing',
    subtitle: 'Let’s try to fix your billing issues.',
    icon: 'fas fa-dollar-sign',
    color: colors.indigo,
  },
  {
    title: 'Customizing',
    subtitle: 'Let’s try to fix your customizing issues.',
    icon: 'fas fa-puzzle-piece',
    color: colors.blue,
  },
  {
    title: 'Organizations',
    subtitle: 'Let’s try to fix your organizational issues.',
    icon: 'fas fa-users',
    color: colors.deepPurple,
  },
];
